import consumerApi from "api/services/consumer-api";
import { ApiResponse, SearchPageTypes } from "custom-types/Search";
import { Coordinates } from "custom-types/Coordinates";
import { stringify } from "qs";

type Query = {
  [key: string]: string | string[] | undefined;
};

const getSearchResults = async (
  query: Query,
  coordinates: Coordinates,
  maxDistance: number,
  countryCode = "US",
  take = 12,
  skip = 0
) => {
  const route = "/api/search/v1";

  const body = stringify(
    {
      ...query,
      ...coordinates,
      // TODO: do we want to include max_distance?
      // "filter[max_distance]": maxDistance || 30,
      take,
      skip,
    },
    {
      arrayFormat: "brackets",
      encodeValuesOnly: true,
    }
  );

  try {
    const { data } = await consumerApi.get<ApiResponse>(`${route}?${body}`, {
      headers: {
        "x-country-code": countryCode,
      },
    });

    const {
      hits: {
        strain,
        brand,
        dispensary,
        article,
        menuItem,
        menuItemDispensary,
      },
      metadata: { availableFilters, relevanceOrder },
    } = data;

    const mappedFilters = availableFilters.map((filter) => ({
      ...filter,
      values: filter.values.map((value) => value.value),
    }));

    const menuItemCategories =
      availableFilters
        .find((filter) => filter.name === "product_category")
        ?.values?.map((values) => values.value) || [];

    const menuItemDispensaries = menuItemDispensary?.slice(0, 2);

    // Return sorted categories that have results
    // Brand and article are manually sorted last
    const categoryRelevanceOrder = Object.entries(relevanceOrder)
      .filter(
        ([key, value]) =>
          value && ["dispensary", "strain", "menuItem"].includes(key)
      )
      .sort(([, aValue], [, bValue]) => bValue - aValue)
      .map(([relevanceType]) => relevanceType) as SearchPageTypes[];
    if (brand?.length) categoryRelevanceOrder.push("brand");
    if (article?.length) categoryRelevanceOrder.push("article");

    return {
      brand: brand || [],
      dispensary: dispensary || [],
      strain: strain || [],
      article: article || [],
      menuItem: menuItem || [], // TODO: send this back a different way?
      menuItemCategories,
      menuItemDispensaries: menuItemDispensaries || [],
      categoryRelevanceOrder,
      availableFilters: mappedFilters,
    };
  } catch (err) {
    return {
      article: [],
      brand: [],
      dispensary: [],
      menuItem: [],
      strain: [],
      menuItemCategories: [],
      menuItemDispensaries: [],
      categoryRelevanceOrder: [],
      availableFilters: [],
    };
  }
};

export default getSearchResults;
